import CitiesApiV2 from 'api/v2/admins/cities-api-v2'
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import StringUtil from 'utils/string-util'
import InputField from 'components/molecules/input-field'

const propTypes = {
  name          : PropTypes.string,
  label         : PropTypes.string,
  required      : PropTypes.bool,
  valueType     : PropTypes.string,
  provinceValue : PropTypes.string
}

const defaultProps = {
  name      : 'city',
  label     : 'City',
  required  : false,
  valueType : 'id'
}

/**
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 * @param {string} valueType - what the form will return value
 * @param {string} provinceValue - either province id or province name
 */
const CitySelectField = ({
  name,
  label,
  required,
  valueType,
  provinceValue,
  ...props
}) => {
  const [ cities, setCities ]       = useState([])
  const [ isLoading, setIsLoading ] = useState(false)

  useEffect(() => {
    if (provinceValue == null) return

    const filter = {
      [ `province_${valueType}` ]: provinceValue
    }

    setIsLoading(true)
    CitiesApiV2.get(filter)
      .then((response) => {
        setCities(response.data.tl_cities)
        setIsLoading(false)
      })
      .catch(() => {
        alert('Failed to fetch Cities')
      })
  }, [ provinceValue, valueType ])

  // eslint-disable-next-line react/prop-types
  const SelectFieldOptions = ({ options, label }) => (
    <>
      <option value='' label={ `Choose ${label}` }/>
      {
        // eslint-disable-next-line react/prop-types
        options.map((option) => (
          <option
            key={ `select-option-city-${option.id}` }
            value={ isStringValue(option[valueType]) ? StringUtil.humanizeUpperCase(option[valueType]) : option[valueType] }
            label={ StringUtil.humanizeUpperCase(option.name) }
          />
        ))
      }
    </>
  )

  const isStringValue = (value) => typeof value === 'string' || value instanceof String

  return (
    <InputField
      type='select'
      label={ label }
      name={ name }
      required={ required }
      disabled={ isLoading }
      { ...props }
    >
      {
        isLoading ?
          <option
            key=''
            value=''
            label='Loading...'
          /> :
          <SelectFieldOptions
            options={ cities }
            label={ label }
          />
      }
    </InputField>
  )
}

CitySelectField.propTypes    = propTypes
CitySelectField.defaultProps = defaultProps

export default CitySelectField
